module.exports = __webpack_public_path__ + "img/middle_1.58ca84c9.png";